import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  useTranslate,
  DateField,
} from 'react-admin';
import ListActions from '../../components/ListActions';
import StudentsFilter from '../../components/StudentsFilter';
import TourStudents from './TourStudents';

const StudentsList = (props) => {
  const translate = useTranslate();
  return (
    <List
      {...props}
      sort={{ field: 'createdAt', order: 'DESC' }}
      actions={
        <ListActions
          {...props}
          tourConfig={TourStudents({ translate })}
          hideCreate
        />
      }
      perPage={1000}
      bulkActionButtons={false}
      filters={<StudentsFilter />}
    >
      <Datagrid rowClick="edit">
        <TextField source="name" label={translate('custom.general.name')} />
        <TextField
          source="platform_id"
          label={translate('custom.students.platformId')}
        />
        <TextField
          label={translate('custom.courses.title')}
          source="courseId.name"
        />
        <TextField
          label={translate('custom.clients.title')}
          source="courseId.clientId.name"
        />
        <TextField label="Precio curso" source="courseId.price" />
        <TextField
          label={translate('custom.licenses.title')}
          source="courseId.licenseId.name"
        />
        <DateField
          label={translate('custom.general.createdAt')}
          source="createdAt"
          showTime
        />
        <DateField label="Última conexión" source="updatedAt" showTime />
      </Datagrid>
    </List>
  );
};

export default StudentsList;
